import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams, useSearchParams } from "react-router-dom";
import moment from "moment";
import CommonService from "../../services/common.service";
import GamePlayerCardModal from "../Player/GamePlayerCardModal";
import GuestCommonheader from "../Element/GuestCommonheader";
import PlayerBadgeModal from "../Player/PlayerBadgeModal";
import PlayerBioModal from "../Player/PlayerBioModal";
const GamePlayerProfile = () => {
  let params = useParams(); // calling the hook
  var player_id = params.id;

  const [searchParams] = useSearchParams();
  const [clubId, setClubId] = useState(searchParams.get("game"));
  const [accountName, setAccountName] = useState(
    searchParams.get("account_name")
  );

  const [playerProfileView, setPlayerProfileView] = useState(0);
  const [playerData, setPlayerData] = useState({});
  const [potm, setPotm] = useState();
  const [playerFP, setPlayerFP] = useState();
  const [avgPoints, setAvgPoints] = useState();
  const [priceChange, setPriceChange] = useState();
  const [bestScore, setBestScore] = useState();
  const [topPlayerByGWKPTS, setTopPlayerByGWKPTS] = useState();
  const [fantasyPoint, setFantasyPoint] = useState();
  const [lastFiveRecord, setLastFiveRecord] = useState();
  const [clubDetails, setClubDetails] = useState({});

  const [getBadges, setGetBadges] = useState([]);
  const [playerSponsor, setPlayerSponsor] = useState({});
  useEffect(() => {
    CommonService.gamePlayerProfile(player_id)
      .then((res) => {
        if (res.success) {
          setPlayerData(res.player_data);
          setPotm(res.potm);
          setPlayerFP(res.player_fp);
          setAvgPoints(res.avgPoints);
          setPriceChange(res.price_change);
          setBestScore(res.best_score);
          setTopPlayerByGWKPTS(res.top_player_by_gwk_point);
          setFantasyPoint(res.temp_fs);
          setLastFiveRecord(res.last_5_record);
          setPlayerProfileView(res.playerProfileViews);
          setPlayerSponsor(res.playerSponsorLogo);
          setClubDetails(res.clubDetails);
        }
      })
      .then(() => {
        CommonService.getGamePlayerBadge(player_id).then((badgeRes) => {
          if (badgeRes.status === 200) {
            setGetBadges(badgeRes.data);
          }
        });
      });
  }, []);

  // Player Card Modal
  const [playerCardShow, setPlayerCardShow] = useState(false);
  const [playerBioShow, setPlayerBioShow] = useState(false);
  const [playerCardData, setPlayerCardData] = useState({});
  const [playerCardModalData, setPlayerCardModalData] = useState({});
  const [imagePath, setImagePath] = useState({});
  const handleClose = () => setPlayerCardShow(false);
  const handleBioClose = () => setPlayerBioShow(false);
  const [playerTeamName, setPlayerTeamName] = useState();
  const [playerGameName, setPlayerGameName] = useState();
  const handlePlayerCardShow = () => setPlayerCardShow(true);
  const handlePlayerBioShow = () => setPlayerBioShow(true);
  const [playerSelected, setPlayerSelected] = useState();

  const playerCardHandle = (item) => {
    setPlayerCardShow(true);
    setPlayerCardData(item);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData(res.data);
        setPlayerTeamName(res.teamName);
        setPlayerGameName(res.gameName);
        setPlayerSelected(res.player_count);
        setImagePath(res.image_path);
        setPlayerProfileView(res.playerProfileViews);
      }
    });
  };
  const playerBioHandle = (item) => {
    setPlayerBioShow(true);
    setPlayerCardData(item);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData(res.data);
        setPlayerTeamName(res.teamName);
        setPlayerGameName(res.gameName);
        setImagePath(res.image_path);
      }
    });
  };

  // show Modal Box
  const [showBadgeModal, setShowBadgeModal] = useState(false);
  const [badgeType, setBadgeType] = useState("");
  const handleBadgeClose = () => {
    setShowBadgeModal(false);
  };
  const handleBadge = (type) => {
    setShowBadgeModal(true);
    setBadgeType(type);
  };

  const [showClaimProfile, setShowClaimProfile] = useState(false);

  const [activeTab, setActiveTab] = useState("fantasy_points");

  const [showGamePass, setShowGamePass] = useState(false);
  const handleCloseGamePass = () => setShowGamePass(false);
  const handleGamePassModalShow = () => {
    setShowGamePass(true);
  };

  return (
    <>
      <GuestCommonheader accountName={accountName} />
      <div className="middle-section">
        <div className="profile-section">
          <div className="container">
            <div className="profilebox">
              <span className="available">{playerData?.position_name}</span>
              <Link
                to={`/account-hub?account_name=${accountName}`}
                className="editprofile"
              >
                Back
              </Link>
              <figure className="profileimg">
                {playerData?.is_avatar === 1 ? (
                  <img
                    src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${playerData.image}`}
                    alt="img"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}player/${playerData?.image}`}
                    alt="img"
                  />
                )}
              </figure>
              <strong className="playercard">
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    playerCardHandle(playerData);
                  }}
                >
                  <i className="fas fa-user"></i>
                </Link>
              </strong>
              &nbsp;
              {playerData?.description !== "null" && (
                <strong className="playercard">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      playerBioHandle(playerData);
                    }}
                  >
                    <i className="fas fa-info"></i>
                  </Link>
                </strong>
              )}
              <div className="playerlist">{playerData?.full_name}</div>
              <ul className="profilelist">
                {playerData?.player_bat_style && (
                  <li>
                    Batting style<span>{playerData?.player_bat_style}</span>
                  </li>
                )}

                {playerData?.player_bowl_style && (
                  <li>
                    Bowling style<span>{playerData?.player_bowl_style}</span>
                  </li>
                )}

                <li>
                  Primary Team<span>{playerData?.team_name}</span>
                </li>
                {potm !== 0 && (
                  <li>
                    POTM<span>{potm}</span>
                  </li>
                )}
                {playerSponsor && (
                  <li>
                    Sponsor<span>{playerSponsor?.name}</span>
                  </li>
                )}

                <li>
                  Badges <br></br>
                  {getBadges?.collector && (
                    <div
                      className="badge rounded-pill arrowClass custom_color1"
                      onClick={() => handleBadge("collector")}
                    >
                      Collector
                    </div>
                  )}{" "}
                  &nbsp;
                  {getBadges?.centurion && (
                    <div
                      className="badge rounded-pill arrowClass custom_color2"
                      onClick={() => handleBadge("centurion")}
                    >
                      Centurion
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.double_ton && (
                    <div
                      className="badge rounded-pill arrowClass custom_color3"
                      onClick={() => handleBadge("double_ton")}
                    >
                      Double Ton
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.taker && (
                    <div
                      className="badge rounded-pill arrowClass custom_color4"
                      onClick={() => handleBadge("taker")}
                    >
                      Taker
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.fifer && (
                    <div
                      className="badge rounded-pill arrowClass custom_color5"
                      onClick={() => handleBadge("fifer")}
                    >
                      Fifer
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.magician && (
                    <div
                      className="badge rounded-pill arrowClass custom_color6"
                      onClick={() => handleBadge("magician")}
                    >
                      Magician
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.provider && (
                    <div
                      className="badge rounded-pill arrowClass custom_color7"
                      onClick={() => handleBadge("provider")}
                    >
                      Provider
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.dependable && (
                    <div
                      className="badge rounded-pill arrowClass custom_color8"
                      onClick={() => handleBadge("dependable")}
                    >
                      Dependable
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.juggernaut && (
                    <div
                      className="badge rounded-pill arrowClass custom_color9"
                      onClick={() => handleBadge("juggernaut")}
                    >
                      Juggernaut
                    </div>
                  )}
                </li>
              </ul>
            </div>
            <div className="contentbox">
              <div className="innerwhitebox">
                <div className="summaryhead">
                  {" "}
                  <h4>{playerData?.full_name}</h4>
                </div>
                <ul className="careersummary">
                  <li>
                    <div className="summarybox">
                      <figure className="circle1">
                        <img
                          src="/images/player_profile/frame-icon1.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>
                        {playerFP !== undefined ? playerFP.toFixed(2) : ""}
                      </strong>
                      <span>Fantasy Points</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle2">
                        <img
                          src="/images/player_profile/frame-icon2.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>${playerData?.svalue}m</strong>
                      <span>Fantasy Value</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle3">
                        <img
                          src="/images/player_profile/frame-icon3.svg"
                          alt="img"
                        />
                      </figure>

                      <strong>
                        <img src="../images/lock-icon.png" alt="img" />
                      </strong>

                      <span>Picked In Teams</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle4">
                        <img
                          src="/images/player_profile/frame-icon4.svg"
                          alt="img"
                        />
                      </figure>

                      <strong>
                        <img src="../images/lock-icon.png" alt="img" />
                      </strong>
                      <span>Picked As Cap</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle5">
                        <img
                          src="/images/player_profile/frame-icon5.svg"
                          alt="img"
                        />
                      </figure>

                      <strong>
                        <img src="../images/lock-icon.png" alt="img" />
                      </strong>
                      <span>Picked As V-Cap</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle1">
                        <img
                          src="/images/player_profile/frame-icon6.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>
                        {avgPoints !== undefined ? avgPoints.toFixed(2) : ""}
                      </strong>
                      <span>Avg Points</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle2">
                        <img
                          src="/images/player_profile/frame-icon7.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>{potm && potm}</strong>
                      <span>POTM</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle3">
                        <img
                          src="/images/player_profile/frame-icon8.svg"
                          alt="img"
                        />
                      </figure>

                      {priceChange >= 0 ? (
                        <strong>{`+$${priceChange}m`}</strong>
                      ) : (
                        <strong>{`-$${Math.abs(priceChange)}m`}</strong>
                      )}

                      <span>Value Change</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle4">
                        <img
                          src="/images/player_profile/frame-icon9.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>{bestScore ? bestScore.toFixed(2) : ""}</strong>
                      <span>Best Score</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle5">
                        <img
                          src="/images/player_profile/info-icon.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>{playerProfileView ?? 0}</strong>
                      <span>Profile Views</span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="innerwhitebox">
                <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="Gameweek-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Gameweek"
                      type="button"
                      role="tab"
                      aria-controls="Gameweek"
                      aria-selected="true"
                    >
                      Rounds
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Matches-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Matches"
                      type="button"
                      role="tab"
                      aria-controls="Matches"
                      aria-selected="true"
                    >
                      Matches
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Performances-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Performances"
                      type="button"
                      role="tab"
                      aria-controls="Performances"
                      aria-selected="true"
                    >
                      Recent
                    </button>
                  </li>
                </ul>

                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="Gameweek"
                    role="tabpanel"
                    aria-labelledby="Gameweek-tab"
                  >
                    <div id="table-scroll1" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table1 table innertable">
                          <thead>
                            <tr>
                              <th>RD</th>
                              <th>PTS</th>
                              <th>R</th>
                              <th>4</th>
                              <th>6</th>
                              <th>MDS</th>
                              <th>WK</th>
                              <th>CS</th>
                              <th>HT</th>
                            </tr>
                          </thead>
                          <tbody>
                            {topPlayerByGWKPTS &&
                              topPlayerByGWKPTS.map((item, key) => (
                                <tr key={key}>
                                  <td>{item.round}</td>
                                  <td>
                                    {item.fp !== undefined
                                      ? item.fp.toFixed(2)
                                      : ""}
                                  </td>
                                  <td>{item.sum_rs}</td>
                                  <td>{item.sum_fours}</td>
                                  <td>{item.sum_sixes}</td>
                                  <td>{item.sum_mdns}</td>
                                  <td>{item.sum_wks}</td>
                                  <td>{item.sum_cs}</td>
                                  <td>{item.sum_hattrick}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Matches"
                    role="tabpanel"
                    aria-labelledby="Matches-tab"
                  >
                    <div id="table-scroll2" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table2 table innertable">
                          <thead>
                            <tr>
                              <th scope="col">Team</th>
                              <th scope="col">Date</th>
                              <th scope="col">Pts</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fantasyPoint &&
                              fantasyPoint.map((item, key) => (
                                <tr key={key}>
                                  <td> {item?.teamName}</td>
                                  {/* <td>
                                  {item.fixture?.teamdata?.get_grade?.grade}
                                </td> */}
                                  <td>
                                    {moment(item.fixture.start_date).format(
                                      "D.MM.YYYY"
                                    )}
                                  </td>
                                  <td>{item.fantasy_points.toFixed(2)}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Performances"
                    role="tabpanel"
                    aria-labelledby="Performances-tab"
                  >
                    <div id="table-scroll4" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table4 table innertable">
                          <thead>
                            <tr>
                              <th scope="col">Team</th>
                              <th scope="col">R</th>
                              <th scope="col">4</th>
                              <th scope="col">6</th>
                              <th scope="col">MDS</th>
                              <th scope="col">WK</th>
                              <th scope="col">FP</th>
                              <th scope="col">VC</th>
                              {/* <th scope="col">FV</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {lastFiveRecord &&
                              lastFiveRecord.map((item, key) => (
                                <tr key={key}>
                                  <td>{item.team_name}</td>
                                  <td>{item?.runs ? item.runs : 0}</td>
                                  <td>{item?.four ? item?.four : 0}</td>
                                  <td>{item?.six ? item?.six : 0}</td>
                                  <td>{item?.maiden ? item?.maiden : 0}</td>
                                  <td>{item?.wks ? item?.wks : 0}</td>
                                  <td>{item?.fp.toFixed(2)}</td>
                                  <td>
                                    {item?.vc >= 0 ? (
                                      <strong>${item?.vc}m</strong>
                                    ) : (
                                      <strong>-${Math.abs(item.vc)}m</strong>
                                    )}
                                  </td>
                                  {/* <td>${item.fv}m</td> */}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="legend-btn">
                  <Link
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#gamekey"
                  >
                    Legend Keys
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="gamekey"
        aria-labelledby="gamekey"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Legend Keys</h5>
            </div>
            <div className="modal-body">
              <div className="column legend">
                <div className="left-column">
                  <ul className="legend">
                    <li>
                      <strong>RD:</strong>
                      <span>Round</span>
                    </li>
                    <li>
                      <strong>PTS:</strong>
                      <span>Points</span>
                    </li>
                    <li>
                      <strong>R:</strong>
                      <span>Runs</span>
                    </li>
                    <li>
                      <strong>4:</strong>
                      <span>Fours</span>
                    </li>
                    <li>
                      <strong>6:</strong>
                      <span>Sixes</span>
                    </li>
                    <li>
                      <strong>MDS:</strong>
                      <span>Maidens</span>
                    </li>
                  </ul>
                </div>
                <div className="right-column">
                  <ul className="legend">
                    <li>
                      <strong>WK:</strong>
                      <span>Wickets</span>
                    </li>
                    <li>
                      <strong>CS:</strong>
                      <span>Catches</span>
                    </li>
                    <li>
                      <strong>HT:</strong>
                      <span>Hat-Trick</span>
                    </li>
                    <li>
                      <strong>VC:</strong>
                      <span>Value Change</span>
                    </li>
                    <li>
                      <strong>FV:</strong>
                      <span>Fantasy Value</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="poweredby">
                Powered By
                <img src="../images/logo.png" alt="img" />
              </div>
              <div className="">
                <Link className="border-btn" data-bs-dismiss="modal">
                  Close
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GamePlayerCardModal
        show={playerCardShow}
        handleClose={handleClose}
        handleShow={handlePlayerCardShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
        playerGameName={playerGameName}
        playerSelected={playerSelected}
        playerProfileView={playerProfileView}
        handleGamePassModalShow={handleGamePassModalShow}
        userPaidForClub={0}
        playerSponsor={playerSponsor}
        clubDetails={clubDetails}
      />
      <PlayerBadgeModal
        showBadgeModal={showBadgeModal}
        handleBadgeClose={handleBadgeClose}
        badgeType={badgeType}
      />
      <PlayerBioModal
        show={playerBioShow}
        handleClose={handleBioClose}
        handleShow={handlePlayerBioShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
        playerGameName={playerGameName}
      />
    </>
  );
};

export default GamePlayerProfile;
